<template>
  <div class="a-synthese-container" v-html="synthese" >
  </div>
</template>

<script>
  export default {
    name: 'CheckupPart0',
    props: ['synthese']
  };
</script>

<style scoped>
	/* CSS inflexsys */
	.a-synthese-container >>> { font-size: 13px; padding: 0px; display:table; width:100%; table-layout:fixed;  }
	.a-synthese-container >>> h1 { text-align: center; font-size: 32px; }
	.a-synthese-container >>> ul { padding-left: 20px; }
	.a-synthese-container >>> ul h4 { margin: 8px 0px; }
	.a-synthese-container >>> ul li { margin: 6px 0px 6px 20px; }
	.a-synthese-container >>> ul p { margin: 6px 0px; }
	.a-synthese-container >>> .x-innerhtml { height: 100%; }
	.a-synthese-container >>> .a-no-data { font-size: 13px !important;  text-align: center; }
  	.a-synthese-container >>> .a-gravite-header { vertical-align: top; height: 100%; display: table-cell; font-size: 18px; width:35px !important; }

	.a-synthese-container >>> .a-gravite-header p { writing-mode: vertical-lr; transform: rotate(180deg); font-size: 22px; font-weight: bold; height: 100%; width: 50%; padding: 0px; margin: auto; margin: -10px 0px 0px 0px;}
	.a-synthese-container >>> .a-synthese-content { height: 100%; overflow: auto; display: table-cell; width: 100%; }
	.a-synthese-container >>> .a-synthese-section { padding: 10px; }
	.a-synthese-container >>> .a-synthese-section:nth-child(even) { background-color: aliceblue; }
	.a-synthese-container >>> .a-synthese-section .a-synthese-body>.a-no-data { font-size: 26px; margin: 50px; }
	.a-synthese-container >>> .a-synthese-bloc { border: 4px solid #b1b1b1; margin: 0.45%; border-radius: 5px; width: 31%; text-align: left; vertical-align: top; display: inline-block; }
	.a-synthese-container >>> .a-synthese-bloc .a-sub-bloc { margin: 12px 5px; }
	.a-synthese-container >>> .a-synthese-bloc .a-sub-bloc ul,
	.a-synthese-container >>> .a-synthese-bloc .a-sub-bloc h4 { margin: 0px; }
	.a-synthese-container >>> .a-synthese-bloc h2 { font-size: 22px; margin: -1px 0 0 -1px; display: inline-block; padding: 4px; color: white; background-color: #b1b1b1 }
	.a-synthese-container >>> .a-synthese-bloc.a-airway-bloc { border-color: #3FAE49; }
	.a-synthese-container >>> .a-synthese-bloc.a-airway-bloc h2 { background-color: #3FAE49; }
	.a-synthese-container >>> .a-synthese-bloc.a-breathing-bloc,
	.a-synthese-container >>> .a-synthese-bloc.a-secondaire-bloc { border-color: #0D6CC1; }
	.a-synthese-container >>> .a-synthese-bloc.a-breathing-bloc h2,
	.a-synthese-container >>> .a-synthese-bloc.a-secondaire-bloc h2 { background-color: #0D6CC1; }
	.a-synthese-container >>> .a-synthese-bloc.a-circulation-bloc { border-color: #D2232B; }
	.a-synthese-container >>> .a-synthese-bloc.a-circulation-bloc h2 { background-color: #D2232B; }
	.a-synthese-container >>> .a-synthese-bloc.a-disability-bloc { border-color: #231F20; }
	.a-synthese-container >>> .a-synthese-bloc.a-disability-bloc h2 { background-color: #231F20; }
	.a-synthese-container >>> .a-synthese-bloc.a-exposure-bloc { border-color: #FFC914; }
	.a-synthese-container >>> .a-synthese-bloc.a-exposure-bloc h2 { background-color: #FFC914; }
	.a-synthese-container >>> .a-victime-section .a-synthese-bloc { width: 47%; }
	.a-synthese-container >>> .a-devenir-section .a-synthese-bloc { border: none; }


	
	/* CSS custom */
	.a-synthese-container >>> { font-size: 13px; height: calc(100% - 4px); }
	.a-synthese-container >>> .a-gravite-header p { width: 100%; color:black ;}
	.a-synthese-container >>> h1 { font-size: 24px; }
	.a-synthese-container >>> .a-synthese-bloc h2 { font-size: 18px; }

  @media only screen and (max-width: 992px) {
	  .a-synthese-container >>> .a-synthese-bloc { border: 4px solid #b1b1b1; margin: 0.45%; border-radius: 5px; width: 47%; text-align: left; vertical-align: top; display: inline-block; }

  }

  @media only screen and (max-width: 767px) {
    .a-synthese-container >>> .a-victime-section .a-synthese-bloc { width: 98%; }
    .a-synthese-container >>> .a-synthese-bloc { border: 4px solid #b1b1b1; margin: 0.45%; border-radius: 5px; width: 98%; text-align: left; vertical-align: top; display: inline-block; }
    .a-synthese-container >>> .a-gravite-header {display: table-row; font-size: 16px; text-align: center; }
    .a-synthese-container >>> .a-gravite-header p { writing-mode: horizontal-tb; transform: rotate(0deg); font-size: 22px; font-weight: bold; height: 100%; width: 50%; padding: 10px 0px; margin: auto; text-align: center; }
  }

</style>